$(document).ready(function () {
  $(document).on("click", ".open-form", function (e) {
    e.preventDefault();
    $(this).slideUp(0);
    $(this).next(".constat-form").slideDown(500);
    $file = $(this).attr("href");
    $form = $(this).parents(".step__infos").find(".wpcf7");

    $(function ($) {
      $form.on("wpcf7mailsent", function () {
        console.log("YESSS");
        window.open($file);
      });
    });
  });

  $(".form__actions .button-step").on("click", async function (e) {
    e.preventDefault();
    $(this).parents(".step__infos").find(".wpcf7").find(".button-pdf").trigger("click");
  });
});
